<template>

    <div class="">
        <header class="">
          <topo :user="userisloged"></topo>

        </header>
        <main>
            <section class="container mx-auto py-8 px-8 md:px-20 vs-con-loading__container" id="div-with-loading">

                <!-- =============================== text area 1 ===============================  -->
                <div>
                    <h1 class="text-center md:text-left text-gray-900 font-bold poppins text-2xl">Ordem {{this.$route.params.token}}</h1>
                    <h2 class="text-center md:text-left poppins text-base">Acompanhe aqui a entrega dos seus produtos</h2>
                    <h3 class="poppins"><i class="fas fa-circle text-green-500 mr-4 mt-4"></i>Enviado</h3>

                </div>

                <!-- =============================== Cupom area ===============================  -->
                <div class="md:flex mt-10 ">

                    <div class="md:w-full lg:w-1/2 md:p-6" v-if="detalhe.endereco">
                        <h6 class="mt-8 poppins text-gray-600 font-normal">Data da ordem</h6>
                        <h4 class="text-2xl md:text-4xl font-bold Arial tracking-widest">{{detalhe.created_at | formatDateTime}}</h4>
                        <h3 class="poppins font-bold text-2x1">{{detalhe.endereco.nome}}</h3>
                        <p class="poppins font-medium text-base text-2x1 text-gray-900">{{detalhe.endereco.email}}</p>
                        <p class="text-center my-2 poppins font-medium text-xs text-white bg-gray-600 p-2 rounded-md w-3/6" >{{detalhe.brinde.nome}}</p>
                        <p class="poppins font-medium text-base text-2x1 text-gray-900">{{detalhe.endereco.endereco + ', ' + detalhe.endereco.numero}}</p>
                        <p class="poppins font-medium text-base text-2x1 text-gray-900">{{detalhe.endereco.bairro}} - {{detalhe.endereco.cidade}} / {{detalhe.endereco.estado}}</p>
                        <p class="poppins font-medium text-base text-2x1 text-gray-900">CEP: {{detalhe.endereco.cep}}</p>
                        <p class="poppins font-medium text-base text-2x1 text-gray-900"><b>Complemento:</b> {{detalhe.endereco.complemento}}</p>
                        <vs-button class="px-3 py-2 mt-3" type="filled" color="primary" v-if="podeEditar(detalhe)"
                                   @click="$router.push({path: `/preencher/${detalhe.uuid}/${detalhe.endereco.email}`})">Editar endereço</vs-button>
                    </div>

                    <div class="w-full lg:w-1/2 mt-6 md:mt-0 md:p-6 ">
                        <h3 class="text-2xl Arial font-bold">O que será entregue</h3>
                        <div class="bg-white border-2 md:mt-3 border-gray-400">
                            <div class=" flex mt-4">
                                <div class="w-4/12 p-6 md:p-10">
                                    <img src="@/assets/images/weentregas/box-logo-black.png" width="100%" alt="">
                                </div>
                                <div class="w-8/12 my-auto">
                                    <h4 class="text-base md:text-lg font-bold text-gray-900 ">{{detalhe.brinde.nome}}</h4>
                                    <p class="text-sm text-gray-600 Arial">O prazo de entrega dependerá do seu endereço de entrega.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section v-if="detalhe.status_melhor_envio == null" class="container  md:py-8 md:px-20 px-8">
                <h1 class="poppins md:text-3xl font-bold text-center">Objeto <span class="text-purple-600">{{(detalhe.rastreio && detalhe.expedicao.fechado) ? detalhe.rastreio : 'aguardando postagem'}}</span></h1>
                <table class=" md:mx-auto table-auto mt-8 poppins md:w-2/3">
                    <tbody>
                    <tr class="border-t border-gray-600" v-for="(item, index) in historicoRastreio" :key="index">
                        <td class="py-2 w-1/6 text-sm font-normal md:pl-16 pt-5 pb-8">
                            <p class="text-xs md:text-sm">{{item.date + ' ' + item.hour}}</p>
                            <p>{{item.location}}</p>
                        </td>
                        <td class="w-2/6 mb-8">
                            <p class="font-bold text-sm">{{item.action}}</p>
                            <p class="font-normal md:text-sm text-xs">{{item.message}}</p>
                        </td>
                    </tr>
                    <tr class="border-t border-gray-600">
                        <td class="py-2 w-1/6 text-sm font-normal md:pl-16 pt-5 pb-8">
                            <p class="text-xs md:text-sm">{{detalhe.endereco.updated_at | formatDateTime}}</p>
                        </td>
                        <td class="w-2/6 mb-8">
                            <p class="font-bold text-sm">Objeto Solicitado</p>
                            <p class="font-normal md:text-sm text-xs">Aguardando postagem</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </section>
            <section v-else class="container  md:py-8 md:px-20 px-8">
                <h1 class="poppins md:text-3xl font-bold text-center">Objeto <span class="text-purple-600">{{(detalhe.rastreio_melhor_envio && detalhe.expedicao.fechado) ? 'postado' : 'aguardando postagem'}}</span></h1>
                <table class=" md:mx-auto table-auto mt-8 poppins md:w-2/3">
                    <tbody>
                    <tr class="border-t border-gray-600" v-for="(item, index) in historicoRastreio" :key="index">
                        <td class="py-2 w-1/6 text-sm font-normal md:pl-16 pt-5 pb-8">
                            <p class="text-xs md:text-sm">{{item.date + ' ' + item.hour}}</p>
                            <p>{{item.location}}</p>
                        </td>
                        <td class="w-2/6 mb-8">
                            <p class="font-bold text-sm">{{item.action}}</p>
                            <p class="font-normal md:text-sm text-xs">{{item.message}}</p>
                        </td>
                    </tr>
                    <tr class="border-t border-gray-600">
                        <td class="w-full text-center mb-8 pt-5" v-if="detalhe.rastreio_melhor_envio">
                            <p class="font-bold text-sm">Acompanhe o objeto no link abaixo</p>
                            <a :href="`https://www.melhorenvio.com.br/rastreio/${detalhe.rastreio_melhor_envio}`" target="_blank" class="font-normal text-primary md:text-sm text-xs">Acompanhar na Melhor Envio</a>
                        </td>
                        <td class="w-full text-center mb-8 pt-5" v-else>
                            <p class="font-bold text-sm">Objeto Solicitado</p>
                            <a class="font-normal md:text-sm text-xs">Aguardando postagem</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </section>
        </main>
    </div>
</template>

<script>
    import moduleWeentrega from "../../store/weentrega/moduleWeentrega";
    import topo from "./components/Topo.vue"

    export default {
        name: 'Detalhamento',
      components: {
        topo
      },
        data(){
            return {
                detalhe: {
                    endereco: {},
                    brinde: {},
                    expedicao: {
                        fechado: 0
                    }
                },
                historicoRastreio: []
            }
        },
        created() {
            if (!moduleWeentrega.isRegistered) {
                this.$store.registerModule("weentrega", moduleWeentrega);
                moduleWeentrega.isRegistered = true;
            }
            if (!this.userisloged) {
                this.$router.push({name: 'login'})
            }
            this.consulta();
        },
        methods: {
            podeEditar(obj){
                let correiosValido = (obj.expedicao != null ? (obj.expedicao.fechado ? false : true) : true);
                if(obj.endereco != null && correiosValido  && (obj.status_melhor_envio == 'pending' || obj.status_melhor_envio == null)){
                    return true
                }
                return false
            },
            consulta(){
                this.$store.dispatch('weentrega/consulta', {token: this.$route.params.token}).then(response => {
                    this.detalhe = response;
                    if(response.rastreio)
                        this.rastrear(response.rastreio);//this.rastrear('PW305864783BR');
                }).catch(() => {
                    this.$router.push({name: 'login'});
                })
            },
            rastrear(val){
                this.$store.dispatch('weentrega/rastreio', {rastreio: val}).then(response => {
                    if(response.erro){
                        /*this.$vs.notify({
                            title: 'Atenção',
                            text: "Objeto ainda não postado",
                            color: 'danger'
                        })*/
                    } else {
                        this.historicoRastreio = response;
                    }
                });
            }
        },
        computed: {
            userisloged() {
                let user = localStorage.getItem('weeLogged')
                return JSON.parse(user);
            },
        }
    }
</script>

<style scoped>
    .boas-vindas {
        background-image: url('../../assets/images/novaintegracao/bg-boas-vindas.png') !important;
        background-size: cover;
        background-position: center;
    }

    .dourado {
        color: #F0A977 !important;
    }

    .btn-next {
        letter-spacing: 3px;
        background-color: #F0A977;
        width: 250px;
        height: 70px;
    }
</style>
